import {
  gridPaginationModelSelector,
  gridPaginationRowCountSelector,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from "@mui/x-data-grid-premium";
import React from "react";
import GridPagination, { GRID_PAGE_SIZE_OPTIONS } from "./GridPagination";

/**
 * `slots={{ pagination: DataGridPaginationSlot }}` for DataGridPremium.
 * Page size options come from the grid's own `pageSizeOptions` prop.
 */
const DataGridPaginationSlot = (): JSX.Element => {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const { page, pageSize } = useGridSelector(apiRef, gridPaginationModelSelector);
  const rowCount = useGridSelector(apiRef, gridPaginationRowCountSelector);

  const pageSizeOptions = rootProps.pageSizeOptions?.length
    ? rootProps.pageSizeOptions.map((option) =>
        typeof option === "number" ? option : option.value
      )
    : GRID_PAGE_SIZE_OPTIONS;

  return (
    <GridPagination
      page={page}
      pageSize={pageSize}
      rowCount={rowCount}
      pageSizeOptions={pageSizeOptions}
      onPageChange={(nextPage) => apiRef.current.setPage(nextPage)}
      onPageSizeChange={(nextSize) => apiRef.current.setPageSize(nextSize)}
    />
  );
};

export default DataGridPaginationSlot;
